import React, { useEffect } from 'react';
// @ts-ignore — RetorikNews may not be in the public type declarations but is exported at runtime
import { RetorikNews } from '@davi-ai/retorik-framework';
import type { RetorikMainComponentConfiguration } from '@davi-ai/retorik-framework';

const defaultTimeoutMilliseconds = 5000;
const defaultTimeoutSeconds = 5;

interface InfoChannelProps {
  injectConfig: RetorikMainComponentConfiguration;
  loop: boolean;
  switchComponent: () => void;
}

const InfoChannel: React.FC<InfoChannelProps> = ({ injectConfig, loop, switchComponent }) => {
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null;
    const handleNewsEnded = () => {
      timer = loop
        ? null
        : setTimeout(
            switchComponent,
            typeof (injectConfig as any).viewsConfig?.views?.news?.intervalInSeconds === 'number'
              ? (injectConfig as any).viewsConfig.views.news.intervalInSeconds * 1000
              : defaultTimeoutMilliseconds
          );
    };
    document.addEventListener('newsEnded', handleNewsEnded);
    return () => {
      document.removeEventListener('newsEnded', handleNewsEnded);
      if (timer) clearTimeout(timer);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Override viewsConfig.views.news.loop to match current loop state (like Kiosk)
  const configWithLoop = {
    ...injectConfig,
    viewsConfig: {
      ...(injectConfig as any).viewsConfig,
      views: {
        ...(injectConfig as any).viewsConfig?.views,
        news: {
          ...(injectConfig as any).viewsConfig?.views?.news,
          background: {
            ...((injectConfig as any).viewsConfig?.views?.news?.background || { style: 'image' }),
          },
          loop,
          intervalInSeconds:
            (injectConfig as any).viewsConfig?.views?.news?.intervalInSeconds ?? defaultTimeoutSeconds,
        },
      },
    },
    skipLoader: true,
  };

  return <RetorikNews {...configWithLoop} />;
};

export default InfoChannel;
